__turbopack_context__.v({
  "container": "UUh2zW_container",
  "content": "UUh2zW_content",
  "interactive": "UUh2zW_interactive",
});
